export enum LinkSkins {
  PRIMARY,
  SECONDARY
}
